export function shouldIncludeTime(rawDate?: string | null): boolean {
  if (!rawDate) return false;

  const eventDate = new Date(rawDate);
  const now = new Date();

  if (Number.isNaN(eventDate.getTime())) return false;

  return eventDate >= new Date(now.toISOString().split('T')[0]);
}
